import { render, staticRenderFns } from "./PeopleView.vue?vue&type=template&id=2ef47bc9&scoped=true&"
import script from "./PeopleView.vue?vue&type=script&lang=js&"
export * from "./PeopleView.vue?vue&type=script&lang=js&"
import style0 from "./PeopleView.vue?vue&type=style&index=0&id=2ef47bc9&prod&lang=scss&"
import style1 from "./PeopleView.vue?vue&type=style&index=1&id=2ef47bc9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef47bc9",
  null
  
)

export default component.exports